import { render, staticRenderFns } from "./aboutHospital.vue?vue&type=template&id=3553bb76&scoped=true&"
import script from "./aboutHospital.vue?vue&type=script&lang=js&"
export * from "./aboutHospital.vue?vue&type=script&lang=js&"
import style0 from "./aboutHospital.vue?vue&type=style&index=0&id=3553bb76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3553bb76",
  null
  
)

export default component.exports